/**
 * Created by joellee on 4/10/15.
 */
dealershipModule.directive('dealerPreferences', function factory() {
    return{
        templateUrl: 'app/modules/dealership/directives/dealer-preferences-directive.html',
        replace: true,
        restrict: 'E',
        controller: 'DealerPreferencesController',
        scope:  {
            product: "=product",
            loading: "=loading",
            promiseSave: "="
        }
    };
});